var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacros({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 2.25h-14c-1.517 0-2.75 1.233-2.75 2.75v14c0 1.517 1.233 2.75 2.75 2.75h14c1.517 0 2.75-1.233 2.75-2.75v-14c0-1.517-1.233-2.75-2.75-2.75zm1.25 16.75c0 .689-.561 1.25-1.25 1.25h-14c-.689 0-1.25-.561-1.25-1.25v-9.25h16.5zm0-10.75h-16.5v-3.25c0-.689.561-1.25 1.25-1.25h14c.689 0 1.25.561 1.25 1.25zm-8.5-2.25c0 .414-.336.75-.75.75h-1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1c.414 0 .75.336.75.75zm-4 0c0 .414-.336.75-.75.75h-1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1c.414 0 .75.336.75.75zm3.5 11c0-.414.336-.75.75-.75h4c.414 0 .75.336.75.75s-.336.75-.75.75h-4c-.414 0-.75-.336-.75-.75zm-3.78-.53 1.47-1.47-1.47-1.47c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l2 2c.293.293.293.768 0 1.061l-2 2c-.146.146-.338.22-.53.22s-.384-.073-.53-.22c-.293-.293-.293-.768 0-1.061z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacros);
export default __webpack_public_path__ + "static/media/macros.fa89f66e12169ba382ecab36a3307e65.svg";
export { ForwardRef as ReactComponent };